import React from "react";
import Modal from "react-bootstrap/Modal";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "default",
  loading = false,
}) => {
  const isDanger = variant === "danger";

  const handleHide = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Modal
      show={isOpen}
      onHide={handleHide}
      centered
      backdrop={loading ? "static" : true}
      keyboard={!loading}
    >
      <Modal.Header closeButton={!loading}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#666",
            lineHeight: "1.5",
          }}
        >
          {message}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-secondary btn-sm"
          onClick={handleHide}
          disabled={loading}
          style={{
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.6 : 1,
          }}
        >
          {cancelText}
        </button>
        <button
          className={isDanger ? "btn-danger btn-sm" : "btn-primary btn-sm"}
          onClick={onConfirm}
          disabled={loading}
          style={{
            cursor: loading ? "wait" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          {loading && (
            <span
              style={{
                display: "inline-block",
                width: "14px",
                height: "14px",
                border: "2px solid rgba(255,255,255,0.3)",
                borderTopColor: "#fff",
                borderRadius: "50%",
                animation: "spin 0.8s linear infinite",
              }}
            />
          )}
          {loading ? "Deleting..." : confirmText}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
